// Constants
import {
  ARNEO_ECOCONCEPTION_AUDITOR,
  ARNEO_ECOCONCEPTION_ACCESS_TOKEN,
} from '../../constants';

// Components
import Header from '../../blocks/Header';
import Button from '../../components/Button';
import Input from '../../components/Input';
import Select from '../../components/Select';
import Checkbox from '../../components/Checkbox';
import Response from '../../components/Response';
import GoogleSignIn from '../../components/GoogleSignIn';
import { tokenIsValid } from '../../utils';

export default {
  name: 'Audit',
  data() {
    return {
      success: false,
      loading: false,
      response: '',
      subResponse: '',
      file: null,
      googleDrive: false,
      googleAuth: false,
      accessToken: null,
      submitButton: "Lancer l'audit",
      options: [
        {
          value: 'prospection',
          label: 'Prospection',
        },
        {
          value: 'ask-prospect',
          label: 'Demande prospect',
        },
        {
          value: 'ask-client',
          label: 'Demande client',
        },
        {
          value: 'rdv-client',
          label: 'RDV client',
        },
        {
          value: 'internal-audit',
          label: 'Audit interne',
        },
        {
          value: 'test',
          label: 'Test',
        },
        {
          value: 'other',
          label: 'Autre',
        },
      ],
      form: {
        auditor: localStorage.getItem(ARNEO_ECOCONCEPTION_AUDITOR),
        context: '',
        contextOther: '',
        website: '',
        email: '',
        urls: [''],
      },
      errors: {
        auditor: '',
        context: '',
        contextOther: '',
        website: '',
        email: '',
        urls: [''],
      },
    };
  },
  components: {
    Header,
    Button,
    AtomInput: Input,
    AtomSelect: Select,
    Checkbox,
    Response,
    GoogleSignIn,
  },
  sockets: {
    analyzeToClient({ status, data }) {
      switch (status) {
        case 'waiting':
          this.handleWaitingAnalyze(data);
          break;
        case 'progress':
          this.handleProgressAnalyze(data);
          break;
        case 'completed':
          this.handleCompletedAnalyze(data);
          break;
        case 'failed':
          this.handleFailedAnalyze();
          break;
      }
    },
    check(data) {
      if (null === data.invalidUrls) {
        // Start Analyzing
        this.startAnalyze(data.validUrls);
      } else {
        const urls = data.invalidUrls;
        this.loading = false;
        this.response = "L'analyse ne peut pas être effectuée.";
        this.submitButton = 'Nouvel audit';
        const list = [];

        urls.forEach((url) => {
          list.push(`<li>${url}</li>`);
        });

        this.subResponse = `Les urls suivantes ne sont pas valides (merci de les remplacer) : <ul>
          ${list.join('')}
        </ul>`;
        this.$socket.client.disconnect();
      }
    },
    exception: function () {
      this.response = this.getErrorMessage("lors de l'envoi du formulaire");
      this.subResponse = '';
      this.loading = false;
      this.submitButton = "Lancer l'audit";
      this.$socket.client.disconnect();
    },
    connect: function () {
      localStorage.setItem('socketId', this.$socket.client.id);
    },
    disconnect: function () {
      localStorage.removeItem('socketId');
    },
    reconnect_attempt: () => {
      this.$socket.client.io.opts.query = {
        socketId: localStorage.getItem('socketId') || '',
      };
    },
    appShutdown: function () {
      this.response = `Votre analyse n'a pas pu être réalisée, veuillez réessayer ultérieurement. Si le problème persiste toujours contacter un <a class="a-link" href="mailto:ecoconception@arneogroup.com?subject=Problème lors de l'audit">administrateur du site</a>`;
      this.subResponse = '';
      this.success = false;
      this.loading = false;
      this.submitButton = "Lancer l'audit";
      this.$socket.client.disconnect();
    },
  },
  computed: {
    hasErrors() {
      let urlsErrors = false;

      if (this.errors.auditor) {
        return true;
      }

      if (this.errors.context) {
        return true;
      }

      if (this.errors.contextOther) {
        return true;
      }

      if (this.errors.website) {
        return true;
      }

      if (this.errors.email) {
        return true;
      }

      urlsErrors = this.errors.urls.some((url) => url);

      if (urlsErrors) {
        return true;
      }

      return false;
    },
  },
  methods: {
    addWebsitePage() {
      this.form.urls.push('');
      this.errors.urls.push('');
    },
    removeWebsitePage(index) {
      this.form.urls.splice(index, 1);
      this.errors.urls.splice(index, 1);
    },
    getErrorMessage(step) {
      return `Une erreur est survenue ${step}, veuillez réessayer ultérieurement ou contacter un <a class="a-link" href="mailto:ecoconception@arneogroup.com?subject=Problème lors de l'audit">administrateur du site</a>`;
    },
    checkUrls(urls) {
      this.$socket.client.connect();
      this.$socket.client.emit('checkUrlsValidity', { urls });
    },
    getErrorMessageForUrls(data) {
      if (!data) {
        return '';
      }

      const urls = [];
      data.diagnostics.forEach((item) => {
        if (item.error) {
          urls.push(`<li>${item.url}</li>`);
        }
      });

      if (urls.length === 0) {
        return '';
      }

      return `Des erreurs ont été détectés lors de l'analyse des urls suivants : <ul>${urls.join(
        '',
      )}</ul>Veuillez réessayer ultérieurement ou contacter un <a class="a-link" href="mailto:ecoconception@arneogroup.com?subject=Problème lors de l'audit">administrateur du site</a>.`;
    },
    handleWaitingAnalyze(data) {
      const position =
        data.position === 1 ? `${data.position}er` : `${data.position}ème`;
      this.response = `Vous êtes ${position} dans la file d'attente`;
      this.subResponse =
        "(Le serveur est actuellement plein, merci de patienter quelques minutes s'il vous plaît)";
    },
    handleProgressAnalyze(data) {
      const progress = data.progress ? data.progress : 0;
      this.response = `Analyse en cours (${progress}%)`;
      this.subResponse =
        "(L'analyse peut prendre du temps, merci de patienter quelques minutes s'il vous plaît)";
    },
    handleCompletedAnalyze(data) {
      this.response = "L'audit est terminé !";
      this.subResponse = '';
      if (this.googleDrive) {
        // User used Goggle Drive to save his file
        this.subResponse =
          '(Vous pouvez retrouver votre audit dans votre Google Drive)';
      }

      this.subResponse += this.getErrorMessageForUrls(data);
      this.submitButton = 'Nouvel audit';
      this.success = true;
      this.loading = false;
      this.$socket.client.disconnect();
    },
    handleFailedAnalyze() {
      this.response = this.getErrorMessage("lors de l'analyse");
      this.subResponse = '';
      this.submitButton = "Lancer l'audit";
      this.success = false;
      this.loading = false;
      this.$socket.client.disconnect();
    },
    /**
     * startAnalyze
     * @param {array} urls
     */
    startAnalyze(urls) {
      // Wait 2 minutes and display message
      this.displayMessageAfterWaiting(this.form.email);

      // Start Analyzing
      this.$socket.client.connect();
      this.$socket.client.emit('analyzeToServer', {
        urls,
        author: this.form.auditor,
        context: this.form.context,
        website: this.form.website,
        saveInGoogleDrive: this.googleDrive,
        token: localStorage.getItem(ARNEO_ECOCONCEPTION_ACCESS_TOKEN),
        email: this.form.email,
      });
    },
    displayMessageAfterWaiting(email) {
      setTimeout(() => {
        if (this.loading) {
          this.response = "L'analyse prend du temps.";
          this.subResponse = `Vous pouvez fermer cette fenêtre. Lorsque que l'analyse sera terminée, vous recevrez une alerte par email à l'adresse suivante : ${email}`;
        }
      }, 60000);
    },
    async startAudit() {
      if (this.loading) return;

      const isAuthenticated = await tokenIsValid();
      if (!isAuthenticated) {
        this.$router.push({ name: 'Login' });
        return;
      }

      this.success = false;
      this.file = null;
      this.response = null;
      this.subResponse = null;
      this.loading = true;

      /**
       * Check if all fields are filled
       */
      if (
        (this.form.context && this.form.context.length > 0) ||
        (this.form.context === 'other' && this.form.contextOther.length > 0)
      ) {
        this.errors.context = '';
      } else {
        this.errors.context = 'Veuillez renseigner un contexte';
      }

      if (this.form.website && this.form.website.length > 0) {
        this.errors.website = '';
      } else {
        this.errors.website = 'Veuillez renseigner un site';
      }

      if (this.form.urls && this.form.urls.length > 0) {
        this.form.urls.forEach((url, index) => {
          if (url.length <= 0) {
            this.errors.urls[index] = 'Veuillez renseigner une page à auditer';
          } else {
            this.errors.urls[index] = '';
          }
        });
      }

      if (this.hasErrors) {
        this.loading = false;

        return;
      }

      this.submitButton = 'Audit en cours';

      /**
       * If user want to save Audit into a Google Sheet in his Drive
       */
      if (this.googleDrive) {
        this.accessToken = null;
        localStorage.removeItem(ARNEO_ECOCONCEPTION_ACCESS_TOKEN);

        if (this.$refs.googleSignIn) {
          this.response = 'En attente des informations Google';

          await this.$refs.googleSignIn.$el.click();
        }
      } else {
        // No Google Drive, start analyze
        this.checkUrls(this.form.urls);
      }
    },
  },
  watch: {
    accessToken(data) {
      if (data) {
        switch (data.type) {
          case 'success':
            this.checkUrls(this.form.urls);
            break;
          case 'error':
            this.loading = false;
            this.submitButton = "Lancer l'audit";
            this.response = data.value;
            break;
        }
      }
    },
  },
};
